import axiosClient from '../api/AxiosConfig';

export const ConceptService = {
  GetPrivateConcept: async () => {
    return (await axiosClient.get('/concept/private')).data;
  },
  CreateConcept: async (data) => (await axiosClient.post('/concept', data)).data,
  EditConcept: async (id, data) => (await axiosClient.put(`/concept/${id}/edit`, data)).data,
  DisableConcept: async (id) => (await axiosClient.patch(`/concept/${id}/disable`)).data,
  EnableConcept: async (id) => (await axiosClient.patch(`/concept/${id}/enable`)).data,
  DeleteConcept: async (id) => (await axiosClient.delete(`/concept/${id}/delete`)).data,
  CreateBrandByConceptId: async (idConcept, data) =>
    (await axiosClient.post(`/concept/${idConcept}/brands`, data)).data,
  DeleteBrand: async (idConcept, idBrand) => (await axiosClient.delete(`/concept/${idConcept}/brands/${idBrand}`)).data,
  EditBrand: async (idConcept, idBrand, data) => (await axiosClient.put(`/concept/${idConcept}/brands/${idBrand}`, data)).data,
};
